import React, { useState, useEffect } from 'react'
import styles from '../../Css/CustomSettings.module.css'
import '../../Css/Common.css'
import Toggle from 'react-toggle'
import ProcessedImageCrop from '../Modals/ProcessedImageCrop';
import Skeleton, { SkeletonTheme } from 'react-loading-skeleton';
import 'react-loading-skeleton/dist/skeleton.css'
// import '@interactjs/auto-start'
// import '@interactjs/actions/drag'
// import '@interactjs/actions/resize'
// import '@interactjs/modifiers'
// import '@interactjs/dev-tools'
// import interact from '@interactjs/interact'
import OverlayModal from '../Modals/OverlayModal';
import ImageSectionModal from '../Modals/ImageSectionModal';


function ImageSection(props) {


    const [new_width, set_new_width] = useState(0)
    const [left_wall_padding, set_left_wall_padding] = useState('')
    const [top_wall_padding, set_top_wall_padding] = useState('')

    const [container_height, set_container_height] = useState(0)
    const [container_width, set_container_width] = useState(0)
    const [new_height, set_new_height] = useState(0)
    const [selectedImaage, setSelectedImaage] = useState('')
    const [tempPosition, setTempPosition] = useState('')
    const [wallHeight, setWallHeight] = useState('')

    const handleSetPosition = (position, wall_height) => {
        // this.props.handlePositionChange(position)

        setTempPosition(position)
        props.setHeight(position)
        setWallHeight(wall_height)
    }


    const handleSliderwidth = () => {
        try {

            let is_height = true

            let contW = document.querySelector("#orgImg_2")?.clientWidth + 20;
            let contH = document.querySelector("#orgImg_2")?.clientHeight;
            var myImg = document.querySelector("#orgImg_2");
            var imgW = myImg?.naturalWidth;
            var imgH = myImg?.naturalHeight;

            var ratio_diff = contH / imgH;
            var new_imgW = imgW * ratio_diff;
            var new_imgH = imgH * ratio_diff;
            var new_wall_width = (new_imgW / contW) * 100
            new_wall_width = String(new_wall_width) + "%"
            // var left_padding = String(((contW - new_imgW)) / 2) + "px"
            var left_padding=(contW - new_imgW) / 2
            if (left_padding < 0) {
                is_height = false
                left_padding = "10px"
                ratio_diff = contW / imgW;
                new_imgW = imgW * ratio_diff;
                new_imgH = imgH * ratio_diff;
                new_wall_width = ((new_imgW -20)/new_imgW) * 100
                new_wall_width = String(new_wall_width) + "%"
                var new_wall_height = (new_imgH / contH) * 100
                new_wall_height = String(new_wall_width) + "%"
                var top_padding = ((contH - new_imgH)+30)/2

                set_top_wall_padding(String(top_padding)+"px")


                contH = new_imgH
                set_new_width(new_wall_width)
                set_left_wall_padding(left_padding)
                set_container_height(new_imgH)
                set_container_width(contW)
                set_new_height(new_wall_height)
                return { is_height, contH ,left_padding}


            }
            else {
                set_new_width(new_wall_width)
                set_left_wall_padding(String(left_padding)+"px")
                set_container_height(contH)
                set_container_width(contW)
                return { is_height, contH ,left_padding}
            }



        }
        catch (e) {
            console.log(e)

        }
    }

    // useEffect(() => {

    //     handleSliderwidth()



    //     interact('.resizable')
    //         .resizable({
    //             edges: { top: false, left: false, bottom: true, right: false },
    //             listeners: {
    //                 move: (event) => {
    //                     let { x, y } = event.target.dataset

    //                     x = (parseFloat(x) || 0) + event.deltaRect.left
    //                     y = (parseFloat(y) || 0) + event.deltaRect.top

    //                     let { is_height, contH ,left_padding} = handleSliderwidth()
    //                     if (!contH) {
    //                         return
    //                     }
    //                     if (is_height) {
    //                         if (event.rect.height > contH) {
    //                             event.rect.height = contH
    //                         }
    //                         if (event.rect.height < 20) {
    //                             event.rect.height = 20
    //                         }

    //                         let pos = (event.rect.height / contH) * 100
    //                         handleSetPosition(pos, event.rect.height)
    //                     }
    //                     else{
    //                         if (event.rect.height > contH) {
    //                             event.rect.height = contH
    //                         }
    //                         if (event.rect.height < 20) {
    //                             event.rect.height = 20
    //                         }

    //                         let pos = (event.rect.height / contH) * 100
    //                         handleSetPosition(pos, event.rect.height)

    //                     }
    //                     Object.assign(event.target.style, {
    //                         width: `${event.rect.width}px`,
    //                         height: `${event.rect.height}px`,
    //                         transform: `translate(${x}px, ${y}px)`
    //                     })

    //                     Object.assign(event.target.dataset, { x, y })
    //                 }
    //             }
    //         })

    // }, [selectedImaage, props.applyWay, props.applyType])

    const showSelectedImage = (e) => {
        setSelectedImaage(e)
    }

    return (
        <div style={{position: "relative"}}>
            
            {props.imageSectionModalImage ? <ImageSectionModal imageSectionModalImage = {props.imageSectionModalImage} setImageSectionModalImage = {props.setImageSectionModalImage}/> : null}
            <div className={[styles['image-area']].join(' ')}>
                {props.isImageHide ?
                    <img src={props.fileList && props.fileList[0] ? props.fileList[0].waterMarkImage : ''} className="overlay-signup" />
                    
                    :
                    <>
                        {props.toggleStatus ?

                            <>

                                {props.spinner ?

                                    (props.frontendData.gifUrl === "" ?

                                        <SkeletonTheme baseColor="#ffd5b0">
                                            <div>
                                                <Skeleton className={[styles['skeleton-size']].join(' ')} />
                                            </div>
                                        </SkeletonTheme>
                                        :
                                        <video autoPlay>
                                            <source src={props.frontendData.gifUrl}></source>
                                        </video>
                                    )
                                    :
                                    (props.cropImage ?
                                        <div className={[styles['image-crop-area']].join(' ')}>
                                            <ProcessedImageCrop
                                                image={props.fileList[0].waterMarkImage}
                                                cropImage={props.cropImage}
                                                handleCroppedImage={props.handleCroppedImage}
                                            />
                                        </div>
                                        :
                                        <>
                                            {props.categoryType === 'fabric' || props.categoryType === 'homeFurnishing' ?
                                                <div className={[styles['fabric-images-col'], "col-md-12"].join(' ')}>
                                                    <div className={[styles['fabric-images-row'], "row"].join(' ')}>
                                                        <div className={[styles['fabric-images'], ""].join(' ')}>
                                                            {!selectedImaage ?
                                                                <img src={props.imgGenerationList[0].waterMarkImage} />
                                                                :
                                                                <img src={selectedImaage} />
                                                            }
                                                        </div>

                                                    </div>
                                                </div>
                                                :
                                                <img src={props.fileList[0].waterMarkImage} />
                                            }
                                        </>
                                    )

                                }
                            </>
                            :
                            <>
                                {props.subCatName === 'suit' || props.subCatName === 'bedsheet' ?
                                    <div className={[styles['fabric-images-col'], "col-md-12"].join(' ')}>
                                        <div className={[styles['fabric-images-row'], "row"].join(' ')}>
                                            {props.subCatName === 'suit' ?
                                                <div className={[styles['fabric-images'], "col-md-4"].join(' ')}>
                                                    <p>Kurti</p>
                                                    <img src={props.fileList && props.fileList[0] ? props.fileList[0].suitUrl : ''} />
                                                    <small>Preview</small>
                                                </div>
                                                :
                                                <div className={[styles['home-furnishing-images'], "col-md-8"].join(' ')}>
                                                    <img src={props.fileList && props.fileList[0] ? props.fileList[0].bedsheetUrl : ''} />
                                                </div>
                                            }
                                            {props.subCatName === 'suit' ?
                                                <div className={[styles['fabric-images'], "col-md-4"].join(' ')}>
                                                    <p>Dupatta</p>
                                                    <img src={props.fileList && props.fileList[0] ? props.fileList[0].dupattaUrl : ''} />
                                                    <small>Preview</small>
                                                </div>
                                                :
                                                <div className={[styles['home-furnishing-images'], "col-md-4"].join(' ')}>
                                                    <img src={props.fileList && props.fileList[0] ? props.fileList[0].pillowUrl : ''} />
                                                </div>
                                            }
                                            {props.subCatName === 'suit' ?
                                                <div className={[styles['fabric-images'], "col-md-4"].join(' ')}>
                                                    <p>Salwar</p>
                                                    <img src={props.fileList && props.fileList[0] ? props.fileList[0].salwarUrl : ''} />
                                                    <small>Preview</small>
                                                </div>
                                                :
                                                null
                                            }
                                        </div>
                                    </div>


                                    :
                                    props.applyType === 'CW' && props.applyWay === 'manually' ?
                                        (
                                            <div id="slider_div" className={[styles['original-image-div']]}>
                                                <img id="orgImg_2" src={props.fileList && props.fileList[0] ? props.fileList[0].url : ''} />
                                                <img className={[styles['resizable'], "resizable"].join(" ")} id="wallImg" src={props.customWall}
                                                    style={{
                                                        position: "absolute", 
                                                        width: new_width, 
                                                        left: left_wall_padding,
                                                        height: new_height ? new_height : 150,
                                                        top: top_wall_padding
                                                    }}
                                                />
                                            </div>
                                        )
                                        :
                                        <img src={props.fileList && props.fileList[0] ? props.fileList[0].url : ''} />
                                }

                            </>
                        }
                    </>

                }
                {props.isImageHide ?
                    <div className="col-12 overlay-content">
                        <div className={[styles["sign-up-div"]]}>
                            <div className={[styles["not-logged-in"]]}>
                                <h4>Unlock the image <button onClick={props.handleModal}>Sign Up</button></h4>
                                <small>Existing User ? <a onClick={props.handleUploadLoginModal}>Login</a></small>
                            </div>
                        </div>
                    </div>
                    : null

                }
                
                {props.isEditingFinish ?
                <div className={[styles['toggle-section'], "sec-2-toggle"].join(' ')}>
                    <p className="mr-5 mt-2">Original</p>
                    <label className="mt-2">
                        {props.fileList && props.fileList[0] && props.fileList[0].waterMarkImage?<Toggle onClick={props.handleToggleImage} icons={false} checked={props.toggleStatus} />
                        :
                        <Toggle onClick={props.handleToggleImage} icons={false} checked={false} />}
                    </label>
                    <p className="ml-5 mt-2">Edited</p>
                </div>:null}
            </div>
            {props.toggleStatus && !props.spinner && !props.isImageHide ?
                <div className={[styles['select-image'], ""].join(' ')}>
                    {props.imgGenerationList.map((e, i) => {
                        return (
                            <div onClick={() => showSelectedImage(e.waterMarkImage)} className={selectedImaage === e.waterMarkImage ? [styles['select-image-active'], ""].join(' ') : [styles['image'], ""].join(' ')}>
                                <img src={e.waterMarkImage} />
                            </div>
                        )

                    })
                    }
                </div>
                :
                null
            }
        </div>
    )
}

export default ImageSection
